<template>
    <component
        :is="tag"
        v-bind="$attrs"
        class="z-tag"
        :class="`z-tag--size-${props.size} z-tag--type-${props.type}`"
        :href="tag === 'a' ? href : false"
    >
        <span class="z-tag__text-wrapper"><span><slot /></span></span>
    </component>
</template>
<script setup>
const props = defineProps({
    tag: {
        type: String,
        default: 'div',
    },
    href: {
        type: String,
    },
    type: {
        type: String,
        validator: prop => [
            'filled',
            'bordered'
        ].includes(prop),
        default: 'bordered'
    },
    size: {
        type: String,
        validator: prop => ['s', 'm', 'l'].includes(prop),
        default: 'm'
    }
})

</script>
<style lang="scss">
.z-tag{

    &--size-l {
        --font-size: 20px;
        --y-padding: 12px;
        --x-padding: 24px;
    }

    &--size-m {
        --font-size: 16px;
        --y-padding: 8px;
        --x-padding: 16px;
    }

    &--size-s {
        --font-size: 12px;
        --y-padding: 4px;
        --x-padding: 12px;
    }

    &--type-bordered{
        --border-color: var(--color-primary);
        --text-color: var(--color-primary);
        --background-color: transparent;
    }
    &--type-filled{
        --border-color: var(--color-primary);
        --text-color: var(--color-white);
        --background-color: var(--color-primary);
    }

    padding: var(--y-padding) var(--x-padding) ;
    font-size: var(--font-size);
    font-weight: 500;
    line-height: 110%;
    letter-spacing: -0.16px;
    color: var(--text-color);
    border-radius: 20px;
    border: 1px solid var(--border-color);
    background: var(--background-color);
}
</style>
